import { createTagsColumnCSV } from 'features/Tags/models/TagsColumn'
import { csvColumnCreatedBy, csvColumnUpdatedBy } from 'features/UI'
import { CSVField } from 'hooks/useExportCSV'
import { useMemo } from 'react'
import { CareArticlePortal } from 'types'
import { formatDate } from 'utils'

export function useArticleCSVField() {
  return useMemo<CSVField[]>(
    () => [
      {
        label: 'Timeline Post Name',
        value: 'name',
      },
      {
        label: 'Linked Learn Library Article',
        value: 'learnArticleName',
      },
      {
        label: 'Published',
        value: ({ isPublished }) => (isPublished ? 'Published' : 'Unpublished'),
      },
      createTagsColumnCSV('articleTags'),
      {
        label: 'Portal',
        value: ({ portal }) => (portal === CareArticlePortal.Caregiver ? 'Caregiver' : 'Trainee'),
      },
      {
        label: 'Creation Date',
        value: ({ createdAt }) => formatDate(createdAt),
      },
      csvColumnCreatedBy(),
      {
        label: 'Last Edited',
        value: ({ updatedAt }) => formatDate(updatedAt),
      },
      csvColumnUpdatedBy(),
    ],
    [],
  )
}
